var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg360(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.372,0H25.628A3.372,3.372,0,0,1,29,3.372v16.86A3.372,3.372,0,0,1,25.628,23.6H3.372A3.372,3.372,0,0,1,0,20.233V3.372A3.372,3.372,0,0,1,3.372,0Z",
    transform: "translate(240 619.698)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233 -614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H38a5,5,0,0,1,5,5V30a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(233 614)",
    fill: "#8d6e63"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.03 618.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.744,8.609V5.164a1.045,1.045,0,0,0-.01-.14c0-.016-.006-.03-.009-.046s-.011-.06-.019-.09c0-.009-.006-.018-.009-.028L12.99,8.587v7.872l6.18-3.091a1.039,1.039,0,0,0,.574-.93V10.889c1.969.987,3.118,2.318,3.118,3.659,0,1.7-1.827,3.358-4.768,4.339l.657,1.972c3.877-1.292,6.189-3.651,6.189-6.31C24.94,12.129,23.047,9.969,19.744,8.609Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.127,16.931,9.657,18.4l1.284,1.284C6,19.3,2.078,17.106,2.078,14.548c0-1.349,1.147-2.672,3.118-3.658v1.548a1.039,1.039,0,0,0,.574.93l6.18,3.09V8.587L5.243,4.861c0,.009-.006.018-.009.028-.008.029-.014.059-.019.09s-.007.03-.009.046a1.045,1.045,0,0,0-.01.14V8.612C1.938,9.955,0,12.156,0,14.548c0,3.818,4.8,6.861,11.145,7.235L9.825,23.19l1.516,1.422,2.926-3.118a1.039,1.039,0,0,0-.023-1.446Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.915,4.107l-5.98-2.99a1.039,1.039,0,0,0-.93,0l-5.98,2.99,6.444,3.58Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.636e9ea6e59f684bafbbb7892d197bce.svg";
export { ForwardRef as ReactComponent };